import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PasswordValidation } from './password-validation';

import { LoadingService } from '../../services/loading.service';
import { SharedService } from '../../services/shared.service';

import { SignService } from '../sign.service';
import { NotificationsService } from '../../services/notifications.service';

@Component({
  selector: 'asv-password-code',
  template: `
    <div class="content-box form-width section-top login">
      <form class="mx-auto" [formGroup]="codeForm" (ngSubmit)="onSubmit()">
        <h2 class="text-center">{{ 'sign.password_code.title' | translate }}</h2>
        <h3 class="text-center">{{ 'sign.password_code.description' | translate }}</h3>
        <div class="form-group mt-5">
          <label for="code">{{ 'forms.fields.code' | translate }}</label>
          <input type="password"
                class="form-control"
                id="code"
                formControlName="code"
                placeholder="{{ 'forms.fields.code' | translate }}">
        </div>

        <div class="form-group mt-5">
          <label for="field_password">{{ 'forms.fields.password' | translate }}</label>
          <div class="password-icon">
            <input type="password"
                 class="form-control"
                 id="field_password"
                 formControlName="password"
                 placeholder="{{ 'forms.fields.password' | translate }}">
          </div>
        </div>

        <div class="form-group mt-5">
          <label for="confirm_password">{{ 'forms.fields.confirm_password' | translate }}</label>
          <div class="password-icon">
            <input type="password"
                 class="form-control"
                 id="confirm_password"
                 formControlName="confirm_password"
                 placeholder="{{ 'forms.fields.confirm_password' | translate }}">
          </div>
        </div>

        <div class="form-group mt-5">
          <button type="submit" class="btn btn-success btn-block">{{ 'buttons.reset_password' | translate }}</button>
          <button type="button" class="btn btn-secondary btn-block" (click)="cancel()">{{ 'buttons.cancel' | translate }}</button>
        </div>
      </form>
    </div>
  `,
  styles: [`
    :host {
      width: 100%;
    }
  `]
})
export class PasswordCodeComponent implements OnInit {
  public codeForm: FormGroup;
  public userEmail: Object;
  public showErrors: boolean;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private signService: SignService,
    private notificationsService: NotificationsService,
    private sharedService: SharedService
  ) {
    this.showErrors = false;
  }

  ngOnInit() {
    this.makeForm();
    this.userEmail = this.sharedService.getUserEmail();
    if (!this.userEmail) {
      this.router.navigateByUrl('forgot-password');
    }
  }

  public makeForm() {
    this.codeForm = this.formBuilder.group({
      code: ['', Validators.required],
      password: ['', Validators.required],
      confirm_password: ['', Validators.required]
    }, {
      validator: PasswordValidation.MatchPassword
    });
  }

  public onSubmit() {

    if (this.codeForm.valid && this.userEmail) {
      delete this.codeForm.value['confirm_password'];
      const formValuesWithEmail = Object.assign(this.codeForm.value, this.userEmail);
      this.loadingService.show();
      this.showErrors = false;
      return this.signService.confirmForgotPassword(formValuesWithEmail).subscribe((response) => {
        const body = JSON.parse(response['_body']);
        if (body.status === 201) {
          this.notificationsService.success('Welcome!');
          this.sharedService.setUserEmail(this.codeForm.value);
          this.router.navigateByUrl('/signin');
        } else {
          this.notificationsService.error(body.error_fields.email);
        }
        this.loadingService.hide();
      }, (error) => {
        this.loadingService.hide();
        this.notificationsService.error(error);
      });
    } else {
      this.showErrors = true;
    }
  }

  public confirm() {
    this.router.navigateByUrl('reset-password');
  }

  public cancel() {
    this.router.navigateByUrl('forgot-password');
  }
}
